var common = require("../../utiles/common.js");
var service = require("../../utiles/service");
var layUtils = require("../../utiles/layUtils");
var judge = require("../../utiles/judge.js");
var message = require("../../utiles/message");

module.exports = {
  register: function () {
    document.createElement("user-info");
    ko.components.register("user-info", {
      viewModel: function (params) {
        var $this = this;
        $this.data = ko.observable("");
        $this.userInfo = ko.observable();
        $this.userInfo(common.fetch("/auth/personSubject/loginPerson").data);
        console.log($this.userInfo());
        $this.isenable = ko.observable("");
        $this.lastLoginDate = common.timestampToTime(
          $this.userInfo().loginDate
        );

        $this.getEffective = function () {
          var individualData = $this.userInfo().individualData;
          var expireDate = "";
          var activeDate = "";
          if (individualData && individualData.activeDate) {
            activeDate = common.timestampToTime(individualData.activeDate);
          }
          if (individualData && individualData.expireDate) {
            expireDate = common.timestampToTime(individualData.expireDate);
          }
          if (activeDate && expireDate) {
            return activeDate + "-" + expireDate;
          } else if (activeDate) {
            return "从" + activeDate + "开始";
          } else if (expireDate) {
            return "到" + expireDate + "结束";
          } else {
            return "未设置生效日期";
          }
        };

        $this.close = function () {
          common.redirectTo("/#/appList");
        };
        $this.formData = {
          fields: [
            {
              display: commonLocal.app.phone,
              fieldName: "phone",
              disabled: true,
              rules: ["required", "phone"],
            },
            {
              display: commonLocal.app.mailbox,
              fieldName: "email",
              disabled: true,
              rules: ["required", "email"],
            },
          ],
          data: $this.userInfo()
            ? {
                phone: $this.userInfo().individualData.phone,
                email: $this.userInfo().individualData.email,
              }
            : null,
          submitText: commonLocal.app.modify,
          noButton: true,
          callback: function (data, callBack) {
            console.log(data);
            common.fetch("/auth/personSubject/updatePerson", {
              type: "POST",
              data: JSON.stringify(data),
              success: function (result) {
                console.log(result);
                layUtils.msg("修改成功");
                callBack();
                $this.userInfo(
                  common.fetch("/auth/personSubject/loginPerson").data
                );
              },
              error: function (data) {
                if (judge.isJSON(data.responseText)) {
                  if (
                    JSON.parse(data.responseText).errorCode ===
                    "TENANT-OR-DOMAIN-ERROR"
                  ) {
                    window.location.href = "/#/tenantError";
                    return false;
                  }
                  message.errorAlert(JSON.parse(data.responseText).message);
                }
                callBack();
              },
            });
          },
        };
      },
      template: require("./UserInfo.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/userInfo/UserInfo.js
// module id = 145
// module chunks = 0